<ul class=" nav navbar-nav">
  <li class="active">
      <a href="javascript:void(0);">Home</a>
      <ul class="sub-menu">
          <li>
              <a routerLink="/index">Home-1</a>
          </li>
          <li>
              <a routerLink="/index-2">Home-2</a>
          </li>
          <li>
              <a routerLink="/index-3">Home-3</a>
          </li> 
          <li>
              <a routerLink="/index-4">Home-4</a>
          </li>                                                                                                                    

      </ul>                                                    
  </li>
  <li>
      <a href="javascript:void(0);">Pages</a>
      <ul class="sub-menu">
          <li>
              <a routerLink="/about-1">About us</a>
          </li>
          <li>
              <a routerLink="/contact-1">Contact us</a>
          </li>
      </ul>
  </li>
  <li>
      <a href="javascript:void(0);">Blog</a>
      <ul class="sub-menu">
          <li><a routerLink="/news-grid">Grid</a></li>
          <li><a routerLink="/news-listing">Listing</a></li>
          <li><a routerLink="/news-masonry">Masonry</a></li>
      </ul>
  </li>
  <li>
      <a href="javascript:void(0);">Works</a>
      <ul class="sub-menu">
          <li><a routerLink="/work-grid">Grid</a></li>
          <li><a routerLink="/work-masonry">Masonry</a></li>

          <li><a routerLink="/project-detail">Project Detail</a></li>                                        
      </ul>
  </li>
  <li>
      <a href="javascript:void(0);">Blog detail</a>
      <ul class="sub-menu">

          <li><a routerLink="/post-gallery">Gallery</a></li>

          <li><a routerLink="/post-right-sidebar">Right Sidebar</a></li>                                        
      </ul>                                    
  </li>
  <li class="submenu-direction">
      <a routerLink="/all-elements">All Elements</a>
  </li>                                      
</ul>